import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { Tenant } from '@kawai/shared';
import { fetchAllTenants } from '../repositories/tenants.js';

/**
 * S-05: テナント一覧（read 専用）の React Query hook。
 *
 * cache key は `['tenants', 'all']`。S-06 以降で create / update を入れたら
 * その mutation 側で `queryClient.invalidateQueries({ queryKey: ['tenants'] })` する。
 */
export function useTenants(): UseQueryResult<Tenant[], Error> {
  return useQuery({
    queryKey: ['tenants', 'all'],
    queryFn: () => fetchAllTenants(),
  });
}
